import React, { memo } from "react";

import Button from "../../../components/Button";
import palette from "../../../components/styles/palette";
import { SAVE_CHANGES } from "../../../constants/strings";

const SaveChangesButton = ({ disabled }) => (
  <Button
    type="submit"
    variant="contained"
    disableElevation
    disabled={disabled}
    bgColor={palette.blue}
    bgColorDisabled={palette.grey}
    border="1px solid #0060A2"
    disableBorder="1px solid #808285"
    data-testid="save-changes"
  >
    {SAVE_CHANGES}
  </Button>
);

export default memo(SaveChangesButton);
